<div class="jumbotron animated fadeIn fast">
  <div class="container-fluid">
    <label class="title">{{ data.title }}</label>
    <div class="row">
      <div class="col col-md-6 col-sm-12">
        <div class="form-group has-feedback div-find" *ngIf="data.admin">
          <input
            class="form-control input-find"
            type="search"
            id="search"
            aria-label="Search"
            mdbInput
            (keyup)="searchTerm$.next($event.target.value)"
            mask="S*"
            placeholder="Buscar por nombre"
          />
          <i class="glyphicon glyphicon-search form-control-feedback"></i>
        </div>
      </div>
      <div *ngIf="!loading" class="col-md-6 col-sm-12 text-right">
        <div *ngIf="data.admin">
          <img class="pointer" src="../../assets/images/pages/add.png" [routerLink]="['/pages/admin/create-user']" />
          <label
            class="add-user-label pointer"
            [routerLink]="['/pages/admin/create-user']">Agregar nuevo usuario ></label
          >
        </div>
        <div *ngIf="!data.admin">
          <label
            class="add-user-label pointer"
            [routerLink]="['/pages/admin/user-management']"
            >Ir a gestión de usuarios ></label
          >
        </div>
      </div>
    </div>
    <app-loading *ngIf="loading"></app-loading>
    <app-no-results
      *ngIf="!loading && !error && users.length === 0"
      [data]="constants.alerts.noResults.noUsers"
    ></app-no-results>
    <app-no-results *ngIf="!loading && error" [data]="error"></app-no-results>
    <div class="table-container" *ngIf="!loading && users.length > 0">
      <table class="table table-striped animated fadeIn">
        <tbody>
          <tr *ngFor="let user of users | paginate: config">
            <td class="col-md-2 first">
              <div class="row">
                <div class="col col-md-4">
                  <span class="property">Nombre</span>
                </div>
                <div class="col col-md-8">
                  <b>{{ user.firstName }}</b>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-4">
                  <span class="property">Apellidos</span>
                </div>
                <div class="col col-md-8">
                  <b>{{ user.lastName }}</b>
                </div>
              </div>
            </td>
            <td class="col-md-2">
              <div class="row">
                <div class="col col-md-6">
                  <span class="property">Tipo de Documento</span>
                </div>
                <div class="col col-md-6">
                  <b class="value">{{ user.docType }}</b>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-6">
                  <span class="property">N° de Documento</span>
                </div>
                <div class="col col-md-6">
                  <b class="value">{{ user.docNumber }}</b>
                </div>
              </div>
            </td>
            <td class="col-md-2">
              <div class="row">
                <div class="col col-md-4">
                  <span class="property">Mail</span>
                </div>
                <div class="col col-md-8">
                  <b class="value">{{ user.email }}</b>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-4">
                  <span class="property">Teléfono</span>
                </div>
                <div class="col col-md-8">
                  <b class="value">{{ user.phone }}</b>
                </div>
              </div>
            </td>
            <td class="col-md-3">
              <div class="row">
                <div class="col col-md-2">
                  <span class="property">Cargo</span>
                </div>
                <div class="col col-md-10">
                  <b class="value">{{ user.charge }}</b>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-2">
                  <span class="property">Perfil</span>
                </div>
                <div class="col col-md-10">
                    <b 
                      *ngFor="let role of user.roles; let last = last;" 
                      class="value">
                      {{ role.fullName }}<span *ngIf="!last">,&nbsp;</span>
                    </b>
                </div>
              </div>
            </td>
            <td *ngIf="data.admin" class="col-md-1">
              <div *ngIf="user.id !== _auth.user.getUserData().userId" class="row actions text-center">
                <div class="col-md-4">
                  <img
                    class="icon pointer"
                    [routerLink]="['/pages/admin/edit-user', user.id]"
                    src="../../assets/images/pages/edit.png"
                  />
                </div>
                <div class="col-md-8">
                  <img
                    class="icon pointer"
                    (click)="delete(user)"
                    src="../../assets/images/pages/delete.png"
                  />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-paginator
  *ngIf="data.admin && !loading && users.length > 5"
  [config]="config"
></app-paginator>
